'use client';

import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="vi">
      <body className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-6 text-center space-y-4">
          <div className="w-12 h-12 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto text-xl font-bold">
            !
          </div>
          <h1 className="text-xl font-bold text-slate-900">Đã xảy ra sự cố tải trang</h1>
          <p className="text-sm text-slate-600">
            {error?.message || 'Không thể tải giao diện. Vui lòng thử lại.'}
          </p>
          {error?.digest && (
            <p className="text-xs font-mono text-slate-400">Mã lỗi: {error.digest}</p>
          )}
          <div className="flex gap-2 justify-center pt-2">
            <button
              onClick={() => reset()}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition"
            >
              Thử lại
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="px-4 py-2 bg-slate-100 text-slate-700 text-sm font-semibold rounded-xl hover:bg-slate-200 transition"
            >
              Về trang chủ
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
